import { Component, ElementRef, OnInit, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { SeguridadService } from '../_services/seguridad.service'
import { Subscription } from 'rxjs/Subscription';

import { PreguntasService } from '../_services/preguntas.service';
import { NormasService } from '../_services/normas.service';
import { EvidenciasService } from '../_services/evidencias.service';

import { DropdownPregunta } from '../_models/preguntabase-dropdown.model';

import { UsuariosService } from '../_services/usuarios.service';
import { EmpresasService } from '../_services/empresas.service';

import {GlobalEventsManager} from "../_services/globaleventsmanager.service";

import {ConfirmDialogModule,ConfirmationService} from 'primeng/primeng';

declare var jQuery:any;

@Component({
  selector: 'normas',
  templateUrl: 'normas_detalle.template.html',
  providers:  [PreguntasService]
})
export class NormasComponent  implements OnInit, OnDestroy {

  questions: any[];
  formulario: string;
  subscription: Subscription;
  listanormas: any = [];
  listanormasfiltro: any = [];
  normaseleccionada: number = 0;
  htmlForm: string;
  detallenorma: boolean = true;
  formnorma: boolean = false;
  historialnorma: boolean = false;
  idNormaHistorial: number = 0;
  normaAbr:string = "";

  iconocerrar: string = 'fa fa-times';
  iconoexpandir: string = 'fa fa-expand';

  puedoeditarnorma: boolean = true;

  listapermisos: any = [];
  permisocrearnorma: boolean = false;

  filterQuery: string = "";
  filterQueryEvidencias: string = "";

  listaevidencias: any = [];
  listaEvidenciasFiltro: any = [];

  formevidencia: boolean = false;
  detalleevidencia: boolean = true;
  puedoeditarevidencia: boolean = true;
  evidenciaseleccionada: number = 0;

  permisocrearevidencia: boolean = false;
  copiaevidencia: boolean = false;
  copianorma: boolean = false;

  mostrarmodal: boolean = false;
  idnormaenlazar: number = 0;

  mostrarFiltros:boolean = false;

  filtroetiquetas: string = "xxxxxxx"; //forzamos así que no encuentre resultados en el listado
  nuevaetiqueta: string = "";
  listaetiquetas: any = [];
  listaetiquetasfiltro: any = [];
  finalizado: boolean = false;
  revisado: boolean = false;
  listaAmbitos: any = [];

  verfiltros: boolean = false;
  listamarcos: any = [];
  listapaises: any = [];
  listacomunidades: any = [];
  listaprovincias: any = [];
  listamunicipios: any = [];
  filtro_id_ambito: number = 0;
  filtro_id_ambito_internacional: number = 0;
  filtro_id_ambito_nacional: number = 0;
  filtro_id_ambito_autonomico: number = 0;
  filtro_id_ambito_provincial: number = 0;
  filtro_id_ambito_local: number = 0;

  constructor(private router:Router,
              private seguridad: SeguridadService,
              private service: PreguntasService,
              private normasService: NormasService,
              private empresasService: EmpresasService,
              private globalEventsManager: GlobalEventsManager,
              private elementRef:ElementRef,
              private usuariosService : UsuariosService,
              private confirmationService: ConfirmationService,
              private evidenciasService: EvidenciasService,
              private activatedRoute: ActivatedRoute){
    //this.questions = service.getQuestions();


  }

  ngOnInit(){
   
    this.globalEventsManager.menuExtendido(true);

    this.seguridad.getLogado();

    this.subscription = this.seguridad.dejoPasarUsuarioEmitter.subscribe((mode)=>{
            if (mode !== null) {
              //console.log("ET: "+mode);
              if (!mode){
                this.router.navigate(['login']);
              }
            }
        });

    let id_norma = this.activatedRoute.snapshot.params["id"];
    if (id_norma){
      //console.log("entro normas");
      this.cargarNorma(id_norma);

    }

    this.getListaNormas();
    this.actualizarBreadcrumb();
    this.getListaPermisos();
    this.getListaEtiquetas();
    this.getListaAmbitos();

    this.getListaMarcos();
    this.getListaPaises();
    this.getListaComunidades();


  }

  ngOnDestroy(){
    this.subscription.unsubscribe();
  }

  getListaPermisos(){
    this.usuariosService.getUsuarioListaPermisos().subscribe(
      data => {
        if (data){
          this.listapermisos = data.json().lista;

          //console.log(this.listapermisos);

          for (let i = 0; i < this.listapermisos.length; i++){

            if (this.listapermisos[i].codigo == "MOD0010"){
              this.permisocrearnorma = true;
            }

            if (this.listapermisos[i].codigo == "MOD0013"){
              this.permisocrearevidencia = true;
            }

          }

        }
      }
    );
  }

  getListaNormas(){
    console.log("voy a recuperar");
    //this.normasService.getListaNormas();
    this.normasService.getListaNormasMaestras(0).subscribe(
      data => {
        console.log(data.json().lista);
        this.listanormas = data.json().lista;

        //formateamos el ambito de las normas
        for (let norma of this.listanormas){
          if (norma.id_ambito == 7){
            norma.descAmbito = norma.marco;
          }
          if (norma.id_ambito == 6){
            norma.descAmbito = norma.localidad;
          }
          if (norma.id_ambito == 3){
            norma.descAmbito = norma.provincia;
          }
          if (norma.id_ambito == 2){
            norma.descAmbito = norma.autonomia;
          }
          if (norma.id_ambito == 1){
            norma.descAmbito = norma.pais;
          }
        }


        this.listanormasfiltro = JSON.parse(JSON.stringify(this.listanormas));
      }
    );
  }

  actualizarBreadcrumb(){
    let breadcrumb: any = [];

    let item = {
      'path':'#',
      'name': 'Captura de Normas'
    };
    breadcrumb.push(item);

    /*if (this.nombrebloqueseleccionado != ""){
      let item = {
        'path':'#',
        'name': this.nombrebloqueseleccionado
      }
      breadcrumb.push(item);
    }*/

    this.globalEventsManager.setNombrePagina(breadcrumb);
  }

  cargarNorma(id){

    this.normaseleccionada = id;

    this.formevidencia = false;

    //this.questions = this.service.getQuestions();
    //console.log(this.questions);
    this.formulario = "";
    this.formulario = "mostrar";

    //this.htmlForm = '<formularionormas [idnorma]="normaseleccionada" ></formularionormas>';

  }

  verNorma(id){
    //this.formulario = "";
    //
    this.formnorma = true;
    this.formevidencia = false;
    this.detallenorma = false;

    this.normaseleccionada = +id;

    this.puedoeditarnorma = false;

    this.cargarNorma(id);

    //this.router.navigateByUrl('/capturadenormas/' +id );
  }

  editarNorma(id_norma:number){
    this.formnorma = true;
    this.detallenorma = false;

    this.normaseleccionada = id_norma;
    this.puedoeditarnorma = true;
    this.cargarNorma(id_norma);
  }

  verHistorialNorma(id_norma:number,normaAbr:string){
    console.log(normaAbr);
    this.historialnorma = true;
    this.detallenorma = false;
    this.idNormaHistorial = id_norma;
    this.normaAbr = normaAbr; 
    console.log(id_norma);

  }
  /*nuevaNorma(){
    //this.router.navigate(['normas','0']);
    this.normaseleccionada = 0;
    this.router.navigateByUrl('/capturadenormas/0');
  }*/

  nuevaNorma(){
    this.editarNorma(0);
  }

  onVoted(agreed: boolean) {
     console.log("entro");

     let nuevaPregunta: any;

     nuevaPregunta = new DropdownPregunta({
       key: 'campo-de-select',
       label: 'Campo de select',
       value: 'opcion33',
       options: [
         {key: 'opcion11',  value: 'Opcion 11'},
         {key: 'opcion22',  value: 'Opcion 22'},
         {key: 'opcion33',   value: 'Opcion 33'},
         {key: 'opcion44', value: 'Opcion 44'}
       ],
       order: 3
     })

     this.questions[2] = nuevaPregunta;


   }

   stripText(val: string){
     var cadena: string = "";

     if (val != null){
       if (val.length>25){
         cadena = val.substr(0, 25)+"...";
       }else{
         cadena = val;
       }
     }

     return cadena;
   }

   expandir(nivel:number){
     console.log('nivel '+ nivel);
     if (nivel == 1){
       (this.detallenorma) ? this.detallenorma = false : this.detallenorma = true;
     }
     if (nivel == 2){
       (this.detalleevidencia) ? this.detalleevidencia = false : this.detalleevidencia = true;
     }
   }

   borrarNorma(id_norma: number){
     this.normasService.deleteNormaMaestra(id_norma).subscribe(
       data => {
         if (data){
           this.cerrar(1);
           this.getListaNormas();
         }
       }
     );
   }

   confirmNorma(id_norma: number) {
       this.confirmationService.confirm({
           message: '¿Seguro que deseas eliminar la norma?',
           accept: () => {
               this.borrarNorma(id_norma);
           }
       });
   }

   onChangeNorma(event){
     if(event){
       this.cerrar(1);
       this.getListaNormas();
     }
   }

   onCloseNorma(event: number){
     this.cerrar(1);
   }

   cerrar(nivel:number){

     //le pasamos el nivel al que tiene que ir

     if (nivel <= 1){
       this.normaseleccionada = 0;
       this.detallenorma = true;
       this.formnorma = false;
     }

     if (nivel <= 2){
       this.evidenciaseleccionada = 0;
       this.detalleevidencia = true;
       this.formevidencia = false;
     }

     this.actualizarBreadcrumb();
   }

   onCloseHistorial(event: number){
    this.cerrarHistorial();
  }

  cerrarHistorial(){

    this.historialnorma = false;
    this.detallenorma = true;
  }

   scrollLienzo(){

     jQuery(".wrap-app").animate({scrollLeft: 5000}, 1000);
   }

   /****************************** evidencias *****************************/

  getEvidencias(id_norma: number ){
    //console.log("entro");
    this.detallenorma = false;
    this.detalleevidencia = true;
    this.formevidencia = false;
    this.formnorma = false;
    this.historialnorma = false;
    this.normaseleccionada = id_norma;
    this.evidenciasService.getListaEvidenciasMaestraNorma(id_norma).subscribe(
      data => {
        //console.log(data.json().lista);
        this.listaevidencias = data.json().lista;
        this.listaEvidenciasFiltro = data.json().lista;
      }
    );
  }

  visualizarEvidencia(id_evidencia: number){
    this.puedoeditarevidencia = false;
    this.copiaevidencia = false;
    this.evidenciaseleccionada = id_evidencia;
    this.getEditarEvidencia(id_evidencia);

  }

  getEditarEvidencia(id_evidencia: number){


    this.detalleevidencia = false;
    this.evidenciaseleccionada = id_evidencia;
    this.formevidencia = true;

    this.scrollLienzo();
  }

  onCloseEvidencia(event: number){
    this.cerrar(2);
  }

  onChangeEvidencia(event){
    //if(event){
    if(event.anadir == false){
      this.cerrar(2);
      this.getEvidencias(this.normaseleccionada);
    }else{
      this.getEvidencias(this.normaseleccionada);
    }

    this.copiaevidencia = false;

  }

  nuevaEvidencia(){

    this.editarEvidencia(0);
  }

  editarEvidencia(id_evidencia:number){
    this.puedoeditarevidencia = true;
    this.copiaevidencia = false;
    this.getEditarEvidencia(id_evidencia);
  }

  copiarEvidencia(id_evidencia:number){
    this.puedoeditarevidencia = true;
    this.copiaevidencia = true;
    this.getEditarEvidencia(id_evidencia);
  }

  borrarEvidencia(id_evidencia: number){

    this.evidenciasService.deleteEvidenciaMaestra(id_evidencia).subscribe(
      data => {
        if (data){
          this.getEvidencias(this.normaseleccionada);
        }
      }
    );
  }

  confirmEvidencia(id_evidencia: number) {
      this.confirmationService.confirm({
          message: '¿Seguro que deseas eliminar la evidencia?',
          accept: () => {
              this.borrarEvidencia(id_evidencia);
          }
      });
  }

  enlazarNorma(id_norma: number){
    this.idnormaenlazar = id_norma;
    this.mostrarmodal = true;
  }

  onChangeModalEnlace(event: any){
    this.mostrarmodal = false;
    this.idnormaenlazar = 0;
  }

  getListaEtiquetas(){
    this.normasService.getListaEtiquetasNorma().subscribe(
      data => {
        if (data){
          this.listaetiquetas = data.json().lista;
        }
      }
    );
  }

  getListaAmbitos(){
    this.normasService.getListaAmbitos().subscribe(
      data => {
        if (data){
          this.listaAmbitos = data.json().lista;
        }
      }
    );
  }

  filtroEtiquetas(){
    if (this.nuevaetiqueta.length > 1){
      this.filtroetiquetas = this.nuevaetiqueta;
    }else{
      this.filtroetiquetas = "xxxxxxx";
    }
  }

  anadirEtiqueta(){
    this.listaetiquetasfiltro.push(this.nuevaetiqueta);
    this.nuevaetiqueta = "";
    this.filtroEtiquetas();
    this.aplicarFiltros();
  }

  eliminarEtiqueta(index: number){
    this.listaetiquetasfiltro.splice(index,1);
    this.aplicarFiltros();
  }

  aplicarFiltros(){

    let auxnormas = this.listanormas;

    this.listanormasfiltro = [];

    //recorremos los filtros de las etiquetas para restringir el array de normas
    if (this.listaetiquetasfiltro.length > 0){
      for (let norma of this.listanormas){

        let aux = 1;

        for (let eti of this.listaetiquetasfiltro){

          if (norma.etiquetas.length > 0){

            let encontrado = 0;

            for (let etiqueta of norma.etiquetas){
              if (etiqueta.descripcion == eti){
                encontrado = 1;
              }
            }

            if (encontrado == 0){
              aux = 0;
            }

          }else{
            aux = 0;
          }

        }

        if (aux == 1){
          this.listanormasfiltro.push(norma);
        }

      }
    }else{
      this.listanormasfiltro = auxnormas;
    }

    auxnormas = this.listanormasfiltro;
    //********************* fin filtro etiquetas **************************

    /*********************** filtro revisado y finalizado ******************/

    if(this.finalizado){
      this.listanormasfiltro = [];
      for (let norma of auxnormas){
        if (norma.finalizado == 1){
          this.listanormasfiltro.push(norma);
        }
      }
    }else{
      this.listanormasfiltro = auxnormas;
    }
    auxnormas = this.listanormasfiltro;

    if(this.revisado){
      this.listanormasfiltro = [];
      for (let norma of auxnormas){
        if (norma.revisado == 1){
          this.listanormasfiltro.push(norma);
        }
      }
    }else{
      this.listanormasfiltro = auxnormas;
    }
    auxnormas = this.listanormasfiltro;
    /*********************** filtro revisado y finalizado ******************/

    /*********************** filtro ambitos ********************************/

    if (this.filtro_id_ambito != 0){
      this.listanormasfiltro = [];
      for (let norma of auxnormas){
        if (norma.id_ambito == this.filtro_id_ambito){
          this.listanormasfiltro.push(norma);
        }
      }
    }else{
      this.listanormasfiltro = auxnormas;
    }

    auxnormas = this.listanormasfiltro;

    if (this.filtro_id_ambito_internacional != 0){
      this.listanormasfiltro = [];
      for (let norma of auxnormas){
        if (norma.id_ambito_internacional == this.filtro_id_ambito_internacional){
          this.listanormasfiltro.push(norma);
        }
      }
    }else{
      this.listanormasfiltro = auxnormas;
    }

    auxnormas = this.listanormasfiltro;

    if (this.filtro_id_ambito_nacional != 0){
      this.listanormasfiltro = [];
      for (let norma of auxnormas){
        if (norma.id_ambito_nacional == this.filtro_id_ambito_nacional){
          this.listanormasfiltro.push(norma);
        }
      }
    }else{
      this.listanormasfiltro = auxnormas;
    }

    auxnormas = this.listanormasfiltro;

    if (this.filtro_id_ambito_autonomico != 0){
      this.listanormasfiltro = [];
      for (let norma of auxnormas){
        if (norma.id_ambito_autonomico == this.filtro_id_ambito_autonomico){
          this.listanormasfiltro.push(norma);
        }
      }
    }else{
      this.listanormasfiltro = auxnormas;
    }

    auxnormas = this.listanormasfiltro;


    if (this.filtro_id_ambito_provincial != 0){
      this.listanormasfiltro = [];
      for (let norma of auxnormas){
        if (norma.id_ambito_provincial == this.filtro_id_ambito_provincial){
          this.listanormasfiltro.push(norma);
        }
      }
    }else{
      this.listanormasfiltro = auxnormas;
    }

    auxnormas = this.listanormasfiltro;


    if (this.filtro_id_ambito_local != 0){
      this.listanormasfiltro = [];
      for (let norma of auxnormas){
        if (norma.id_ambito_local == this.filtro_id_ambito_local){
          this.listanormasfiltro.push(norma);
        }
      }
    }else{
      this.listanormasfiltro = auxnormas;
    }

    auxnormas = this.listanormasfiltro;
    /*********************** filtro ambitos ********************************/


    this.listanormasfiltro = auxnormas;

    console.log(this.listanormasfiltro);

  }

  onSaveFinalizado(value:boolean){
    this.finalizado = value;
    this.aplicarFiltros();
  }

  onSaveRevisado(value:boolean){
    this.revisado = value;
    this.aplicarFiltros();
  }

  resetAmbitos(){
    this.filtro_id_ambito_nacional = 0;
    this.filtro_id_ambito_internacional = 0;
    this.filtro_id_ambito_autonomico = 0;
    this.filtro_id_ambito_provincial = 0;
    this.filtro_id_ambito_local = 0;
  }

  getListaMarcos(){

    let params = {
      action: "ListagetMarcos"
    }

    this.empresasService.getSelect(params).subscribe(
        data => {
          if (data){
            this.listamarcos = data.json().lista;
          }
        }
    );

  }

  getListaPaises(){

    let params = {
      action: "ListagetPaises"
    }

    this.empresasService.getSelect(params).subscribe(
        data => {
          if (data){
            this.listapaises = data.json().lista;
          }
        }
    );

  }

  getListaComunidades(){

    let params = {
      action: "ListagetComunidades"
    }

    this.empresasService.getSelect(params).subscribe(
        data => {
          if (data){
            this.listacomunidades = data.json().lista;
          }
        }
    );

  }

  getListaProvincias(id_comunidad: any){

    let params = {
      action: "ListagetProvincias",
      id_comunidad: id_comunidad
    }

    this.empresasService.getSelect(params).subscribe(
        data => {
          if (data){
            this.listaprovincias = data.json().lista;
            this.filtro_id_ambito_local = 0;
            this.aplicarFiltros();
          }
        }
    );

  }

  getListaMunicipios(id_provincia: number){

    let params = {
      action: "ListagetMunicipios",
      id_provincia: id_provincia
    }

    this.empresasService.getSelect(params).subscribe(
        data => {
          if (data){
            this.listamunicipios = data.json().lista;
            this.aplicarFiltros();
          }
        }
    );

  }

//---------------------------------------------------------------------
//-                            FILTROS
//---------------------------------------------------------------------
   
limpiarFiltros(){
    
  this.getEvidencias(this.normaseleccionada);
console.log('dfedgfrreh');

}

changeValueEvidenciaFiltros(filtro){

 this.listaevidencias = filtro;
 if (filtro.tipo == 'limpiar' ){
   this.limpiarFiltros();      
 }else{
   this.listaevidencias = filtro.value;
 
 }

 }

}



// WEBPACK FOOTER //
// ./src/app/normas/normas.component.ts